import { create } from "zustand";
import { MAX_EMAILS } from "../../constants/profile";
export const useEmailStore = create((set) => ({
    emails: [],
    initialEmails: [],
    setInitialEmails: (emails) => set({
        emails: emails?.slice(0, MAX_EMAILS) || [],
        initialEmails: emails?.slice(0, MAX_EMAILS) || [],
    }),
    updateInitialEmails: () => set((state) => ({
        initialEmails: [...state.emails],
    })),
    resetToInitialEmails: () => set((state) => ({
        emails: [...state.initialEmails],
    })),
    updateEmailStatus: (email, updates) => set((state) => ({
        emails: Array.isArray(state.emails)
            ? state.emails.map((item) => item.email === email ? { ...item, ...updates } : item)
            : [],
    })),
    addEmail: (newEmail) => set((state) => {
        if (state.emails.length >= MAX_EMAILS) {
            return { emails: state.emails };
        }
        return { emails: [...state.emails, newEmail] };
    }),
    removeEmail: (email) => set((state) => ({
        emails: Array.isArray(state.emails)
            ? state.emails.filter((item) => item.email !== email)
            : [],
    })),
}));
//# sourceMappingURL=emailStore.js.map